
































import { AppModule } from '@/store/modules/app';
// import { getPickerOptions } from '@/utils/function_utils';
import StudentOfferInformationComp from './StudentOfferInformationComp.vue'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getStuDataApi } from '@/api/student-management'

@Component({
  name: 'studentOfferInformation',
  components: {
    StudentOfferInformationComp
  }
})
export default class extends Vue {
  @Prop({ default: () => [] }) public datas!: any[];

  // get language() {
  //   return AppModule.language;
  // }

  // public dateRange = [];

  // public pickerOptions = getPickerOptions();

  // @Watch('language', { immediate: true })
  // public onLanguageChange() {
  //   const lastWeek = this.$t('common.lastWeek');
  //   const lastMonth = this.$t('common.lastMonth');
  //   const lastThreeMonths = this.$t('common.lastThreeMonths');
  //   this.pickerOptions.shortcuts[0].text = lastWeek;
  //   this.pickerOptions.shortcuts[1].text = lastMonth;
  //   this.pickerOptions.shortcuts[2].text = lastThreeMonths;
  // }

  public async clickOfferItem(item: any) {
    const itemId = item.id;
    const id = item.fkStudentId;
    const source = item.stuSource;
    try {
      const { data } = await getStuDataApi(id, source);
      const stu = `${data.data.lastName} ${data.data.firstName}`;
      sessionStorage.setItem('tab', 'applyDetail');
      this.$router.push({ name: 'studentInformation', query: { source, itemId, stu }, params: { id } });
    } catch (error) {
      //
    }
  }

  // public handleDateChange(dataRange: any) {
  //   this.$emit('updated-datas', dataRange);
  // }
}
